import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    ticketList: [],
    ticketListCount: null,
    ticketFilter: {
        main_filter: null,
        fields: {
            ticketNumber: null,
            ticketTitle: null,
            ticketDescription: null,
            ticketClosed: null,
        },
    },
    ticketModalOpen: false,
    ticket_id: null,
    ticket_index: null,
    status_id: null,
    statuses: [],
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
